<template>
  <div class="products-container">
    <div class="base-row-flex products-header">
      <div v-if="isCrossSell" class="cross-sell-header">
        <span>Detalhes do Combo</span>
        <span class="cross-sell-max-per-client">
          <strong>Máx. por CPF: </strong>{{ offerSchedule.cross_sell_offer_sales[0].trigger_rules.maximum_per_client }}
        </span>
      </div>
      <div v-else class="base-row-flex">
        <span>Produtos</span>
        <number-chip :number="getProductsLength" />
        <industry-chip :industry="offerSchedule.industry" />
      </div>
      <div>
        <mf-search v-model="search" placeholder="Busque um produto" hide-details dense />
      </div>
    </div>

    <offer-sales-cross-sell v-if="isCrossSell" :offer-sales="getOfferSalesFromOfferSchedule" :search="search" />
    <offer-sales-expandable-group
      v-else-if="isProductsGroup"
      :offer-sale="getGroupOfferSaleFromOfferSchedule"
      :type="offerSchedule.types[0]"
      :search="search"
      :external-synchronization="offerSchedule.external_synchronization"
    />
    <offer-sales-digital-voucher v-else-if="isVoucherDigital" :offer-sales="filteredOffers" />
    <offer-sales-common
      v-else
      :offer-sales="filteredOffers"
      :type="offerSchedule.types[0]"
      :external-synchronization="offerSchedule.external_synchronization"
    />
  </div>
</template>

<script>
import OfferSalesCommon from '../offer-sales/OfferSalesCommon.vue'
import OfferSalesCrossSell from '../offer-sales/cross-sell/OfferSalesCrossSell.vue'
import OfferSalesExpandableGroup from '../offer-sales/OfferSalesExpandableGroup.vue'
import OfferSalesDigitalVoucher from '../offer-sales/OfferSalesDigitalVoucher.vue'
import NumberChip from '../offer-sales/NumberChip.vue'
import IndustryChip from '../offer-schedule-list/IndustryChip.vue'
import { normalizeText } from '@/modules/industria/helpers/searchHelper.js'

export default {
  name: 'OfferProductsList',
  components: {
    OfferSalesCommon,
    OfferSalesCrossSell,
    OfferSalesExpandableGroup,
    OfferSalesDigitalVoucher,
    NumberChip,
    IndustryChip,
  },
  props: {
    offerSchedule: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    search: '',
  }),
  computed: {
    currentOfferTypeKeyName() {
      return this.offerSchedule?.types?.[0]
    },
    isCrossSell() {
      return this.offerSchedule.types[0] === 'cross_sell_offer_sales'
    },
    isVoucherDigital() {
      return this.offerSchedule.types[0] === 'dynamic_rule_offer_sales'
    },
    isProductsGroup() {
      if (this.isVoucherDigital) {
        return Boolean(this.offerSchedule?.[this.currentOfferTypeKeyName]?.[0]?.trigger_products[0]?.group_id)
      } else {
        return Boolean(this.offerSchedule?.[this.currentOfferTypeKeyName]?.[0]?.isGroup)
      }
    },
    filteredOffers() {
      let products = this.offerSchedule?.[this.currentOfferTypeKeyName]
      return products.filter((offer) => {
        const searched = normalizeText(this.search)
        const product = this.isVoucherDigital ? offer?.trigger_products[0] : offer
        return (
          normalizeText(product.name).includes(searched) || product.sku.includes(searched) || product.ean.includes(searched) || product.eans.includes(searched)
        )
      })
    },
    getOfferSalesFromOfferSchedule() {
      return this.offerSchedule?.[this.currentOfferTypeKeyName]
    },
    getGroupOfferSaleFromOfferSchedule() {
      return this.getOfferSalesFromOfferSchedule[0]
    },
    getProductsLength() {
      if (this.isProductsGroup) {
        if (this.isVoucherDigital) {
          return this.getGroupOfferSaleFromOfferSchedule?.trigger_products?.length
        } else {
          return this.getGroupOfferSaleFromOfferSchedule?.products?.length
        }
      } else {
        return this.getOfferSalesFromOfferSchedule?.length
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.base-row-flex {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  @media screen and (max-width: $xs-breakpoint) {
    align-items: unset;
  }
}

.cross-sell-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.products-container {
  padding: 16px 0px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0px 2px 4px 0px #0000001a;

  .products-header {
    padding: 0px 40px 16px 40px;
    border-bottom: 1px solid $cinza-l70;
    justify-content: space-between;

    @media screen and (max-width: $xs-breakpoint) {
      padding: 0 16px 16px 16px;
      flex-direction: column;
    }

    span {
      font-size: 18px;
      font-weight: bold;
      color: $cinza-d10;
    }

    .cross-sell-max-per-client {
      font-size: 14px;
      font-weight: normal;
      color: $cinza-0;
    }
  }
}
</style>
